import { render, staticRenderFns } from "./ProfileComp.vue?vue&type=template&id=daf5ba76&scoped=true&"
import script from "./ProfileComp.vue?vue&type=script&lang=js&"
export * from "./ProfileComp.vue?vue&type=script&lang=js&"
import style0 from "./ProfileComp.vue?vue&type=style&index=0&id=daf5ba76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf5ba76",
  null
  
)

export default component.exports